import React from 'react';

const Partners: React.FC = () => {
  const partners = [
    {
      name: 'TP-Link Thailand',
      category: 'Network/WiFi',
      description: 'Omada, GPON, Vigi, TAPO',
      logo: '🔗'
    },
    {
      name: 'HIP Global',
      category: 'Barrier & Access Control',
      description: 'Solar Cell, Access Control Systems',
      logo: '🏢'
    },
    {
      name: 'Secure Serve / AzKing',
      category: 'IoT & Smart Home',
      description: 'Alpha Techno Soft, Fiber Optic, Antivirus',
      logo: '🔒'
    },
    {
      name: 'Indigy, 27Antz',
      category: 'ERP & Workflow',
      description: 'Application Development',
      logo: '⚙️'
    }
  ];

  const clients = [
    'Kerry Express',
    'มหาวิทยาลัยนเรศวร',
    'Slim Up Clinic',
    'Masterpiece Hospital',
    'Racer',
    'SNC Sound Proof',
    'บริษัทน้ำตาลครบุรี',
    'Ayutthaya City Park',
    'Kvik Furniture'
  ];

  return (
    <section id="partners" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-napa-blue-800 mb-4">
            พันธมิตรและลูกค้า
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            เราได้รับความไว้วางใจจากพันธมิตรและลูกค้าชั้นนำในหลากหลายอุตสาหกรรม
          </p>
        </div>

        {/* Strategic Partners */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-napa-blue-800 mb-8 text-center">
            พันธมิตรเชิงกลยุทธ์
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {partners.map((partner, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg card-hover text-center border border-gray-200"
              >
                <div className="text-4xl mb-4">{partner.logo}</div>
                <h4 className="text-lg font-bold text-napa-blue-800 mb-2">
                  {partner.name}
                </h4>
                <p className="text-sm text-napa-blue-600 mb-2 font-medium">
                  {partner.category}
                </p>
                <p className="text-xs text-gray-600">
                  {partner.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Client Logos */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-napa-blue-800 mb-8 text-center">
            ลูกค้าของเรา
          </h3>
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {clients.map((client, index) => (
                <div
                  key={index}
                  className="text-center p-4 rounded-lg bg-gray-50 hover:bg-napa-blue-50 transition-colors duration-200"
                >
                  <div className="text-sm font-medium text-napa-blue-800">
                    {client}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-napa-blue-500 to-napa-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-white text-2xl">🏆</span>
            </div>
            <h4 className="text-lg font-bold text-napa-blue-800 mb-2">
              คุณภาพที่ได้รับการยอมรับ
            </h4>
            <p className="text-gray-600 text-sm">
              ผลิตภัณฑ์และบริการคุณภาพสูงจากแบรนด์ชั้นนำ
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-napa-blue-500 to-napa-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-white text-2xl">🤝</span>
            </div>
            <h4 className="text-lg font-bold text-napa-blue-800 mb-2">
              ความสัมพันธ์ระยะยาว
            </h4>
            <p className="text-gray-600 text-sm">
              สร้างความสัมพันธ์ที่ยั่งยืนกับลูกค้าและพันธมิตร
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-napa-blue-500 to-napa-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-white text-2xl">⚡</span>
            </div>
            <h4 className="text-lg font-bold text-napa-blue-800 mb-2">
              นวัตกรรมที่ทันสมัย
            </h4>
            <p className="text-gray-600 text-sm">
              เทคโนโลยีล่าสุดและโซลูชันที่ตอบสนองความต้องการ
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
